import { render, staticRenderFns } from "./moreNews.vue?vue&type=template&id=6726ee88&scoped=true&"
import script from "./moreNews.vue?vue&type=script&lang=js&"
export * from "./moreNews.vue?vue&type=script&lang=js&"
import style0 from "./moreNews.vue?vue&type=style&index=0&id=6726ee88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6726ee88",
  null
  
)

export default component.exports